import React, { createContext, useContext, useState } from "react";
import { CircularProgress, Backdrop } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

interface ImageUploadContextType {
  isUploading: boolean;
  startUpload: (message?: string) => void;
  endUpload: () => void;
}

const ImageUploadContext = createContext<ImageUploadContextType | null>(null);

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: 9999,
    color: "#fff",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  text: {
    fontSize: "16px",
    fontWeight: 500,
  },
}));

export function ImageUploadProvider({ children }: { children: React.ReactNode }) {
  const [isUploading, setIsUploading] = useState(false);
  const [message, setMessage] = useState("Uploading image...");
  const classes = useStyles();

  const startUpload = (msg?: string) => {
    setMessage(msg || "Uploading image...");
    setIsUploading(true);
  };
  const endUpload = () => {
    setIsUploading(false);
    setMessage("Uploading image...");
  };

  return (
    <ImageUploadContext.Provider value={{ isUploading, startUpload, endUpload }}>
      {children}
      <Backdrop open={isUploading} className={classes.backdrop}>
        <CircularProgress color="inherit" size={60} />
        <div className={classes.text}>{message}</div>
      </Backdrop>
    </ImageUploadContext.Provider>
  );
}

export function useImageUpload() {
  const context = useContext(ImageUploadContext);
  if (!context) {
    throw new Error("useImageUpload must be used within ImageUploadProvider");
  }
  return context;
}
